<div class="loader-container">

    <!-- Spinner with center icon -->
    <div class="spinner-wrapper">
        <div class="spinning-ring"></div>
        <div class="spinning-ring ring-2"></div>
        <div class="center-icon">
            <mat-icon>{{ centerIcon }}</mat-icon>
        </div>
    </div>

    <!-- Progress bar -->
    <div class="progress-bar-wrap">
        <div class="progress-bar-track">
            <div class="progress-bar-fill" [style.width.%]="progress"></div>
        </div>
        <span class="progress-pct">{{ progress }}%</span>
    </div>

    <!-- Active step headline with cursor -->
    <div class="status-card">
        <div class="icon-circle">
            <mat-icon>{{ steps[currentStep].icon || 'hourglass_empty' }}</mat-icon>
        </div>
        <span class="status-text">{{ steps[currentStep].text }}<span class="cursor">|</span></span>
    </div>

    <!-- Steps list -->
    <div class="steps-list">
        <div class="step-item"
            *ngFor="let step of steps; let i = index"
            [class.active]="i === currentStep"
            [class.completed]="i < currentStep"
            [class.pending]="i > currentStep">
            <div class="step-icon">
                <mat-icon *ngIf="i < currentStep">check_circle</mat-icon>
                <mat-icon *ngIf="i >= currentStep">{{ step.icon }}</mat-icon>
            </div>
            <span class="step-text">{{ step.text }}</span>
            <span class="dots" *ngIf="i === currentStep">
                <span>.</span><span>.</span><span>.</span>
            </span>
        </div>
    </div>

    <p class="footer-text">This usually takes a few seconds…</p>
</div>